import { EMAIL_REGEX } from '@constants/regex.constant'
import { capitalizeText } from '@utils/capitalize-text'

export const phoneNumberValidator = {
  getMessage: () => 'Please enter a valid Contact Number',
  validate: (value) => {
    if (!value || value?.length === 0) return true

    const phoneRegex = /^[0][1-9]\d{9}$|^[0][0][1-9]\d{8,12}$|^[+][1-9]\d{9,13}$/g
    return phoneRegex.test(value)
  },
}

export const emailAddressValidator = {
  getMessage: () => 'Please enter a valid e-mail address',
  validate: (value) => {
    if (!value || value?.length === 0) return true

    return EMAIL_REGEX.test(value)
  },
}

export const emailsAddressValidator = {
  getMessage: () => 'Please enter a valid e-mail address for each email',
  validate: (emails) => {
    return emails.split(',').findIndex((email) => !EMAIL_REGEX.test(email)) < 0
  },
}

export const networkRailDomain = {
  getMessage: () => 'Must input the Network Rail email domain',
  validate: (emails) => {
    return emails.split(',').findIndex((email) => !email.includes('@networkrail.co.uk')) < 0
  },
}

export const passwordValidator = {
  getMessage: () =>
    'Your password must be at least 9 characters and must contain at least one letter, one number and one special character',
  validate: (value) => {
    if (!value || value?.length === 0) return true

    const passwordRegex = /^(((?=.*[a-zA-Z])(?=.*\d))(?=.*[^a-zA-Z0-9])).{9,}$/
    return passwordRegex.test(value)
  },
}

export const idValidator = {
  getMessage: (field) => 'Please enter a valid ' + field,
  validate: (value) => {
    const referenceRegex = /[\w]*$/
    return referenceRegex.test(value)
  },
}

export const headcodeValidator = {
  getMessage: () => 'Please enter a valid headcode',
  validate: (value) => {
    if (!value || value?.length === 0) return true

    const regex = /^[a-zA-Z0-9]{4}$/
    return regex.test(value)
  },
}

export const alphaNumeric8CharsValidator = {
  getMessage: (field) => 'Please enter a valid ' + field.field || field,
  validate: (value) => {
    if (!value || value?.length === 0) return true

    const regex = /^[a-zA-Z0-9]{8}$/
    return regex.test(value)
  },
}

export const coachLetterValidator = {
  getMessage: (field) => 'Please enter a valid ' + field.field || field,
  validate: (value) => {
    if (!value || value?.length === 0) return true

    const regex = /^[A-Za-z]{1}$/
    return regex.test(value)
  },
}

export const seatNumberValidator = {
  getMessage: (field) => 'Please enter a valid ' + field.field || field,
  validate: (value) => {
    if (!value || value?.length === 0) return true

    const regex = /^\d{0,4}\w{1}$/
    return regex.test(value)
  },
}

export const bookingNumberValidator = {
  getMessage: (field) => 'Please enter a valid ' + field.field || field,
  validate: (value) => {
    if (!value || value?.length === 0) return true

    const regex = /^[Pp][Aa]-[\w]{8}/
    return regex.test(value)
  },
}

export const usernameValidator = {
  getMessage: () => 'Username must be 3-16 characters, lower case letters, numbers and periods. ',
  validate: (value) => {
    if (!value || value?.length === 0) return true

    const regex = /^[a-z0-9_.-]{3,16}$/
    return regex.test(value)
  },
}

export const roleNameValidator = {
  getMessage: () => 'Please enter a valid role name.',
  validate: (value) => {
    if (!value || value?.length === 0) return true

    const regex = /^[^\s]/
    return regex.test(value)
  },
}

export const textIsOnlyBlanks = {
  getMessage: () => 'Please enter a valid input in Other field.',
  validate: (value) => {
    const regex = /\S/
    return regex.test(value)
  },
}

export const dictionary = {
  messages: {
    booking_number: bookingNumberValidator.getMessage,
    seat_number: seatNumberValidator.getMessage,
    coach_letter: coachLetterValidator.getMessage,
    email_address: emailAddressValidator.getMessage,
    password: passwordValidator.getMessage,
    phone_number: phoneNumberValidator.getMessage,
    id: idValidator.getMessage,
    role_name: roleNameValidator.getMessage,
    blank_text: textIsOnlyBlanks.getMessage,
    alpha_numeric8_chars: alphaNumeric8CharsValidator.getMessage,
    headcode: headcodeValidator.getMessage,
    username: usernameValidator.getMessage,
    emails_address: emailsAddressValidator.getMessage,
    network_rail_domain_email: networkRailDomain.getMessage,
    confirmed: (field) => {
      return `The password confirmation does not match`
    },
    min: (field) => {
      return `The ${field.field} field must be at least ${field.rule.params[0]} characters`
    },
    max: (field) => {
      const fieldName = field.field.toLowerCase()

      if (fieldName === 'first name' || fieldName === 'last name')
        return `The ${capitalizeText(fieldName)} field may not be greater than ${field.rule.params[0]} characters`

      const isDepMeetingPoint = fieldName.includes('dep-text')
      if (isDepMeetingPoint || fieldName.includes('arr-text'))
        return `The ${isDepMeetingPoint ? 'DEP' : 'ARR'} Meeting Point field may not be greater than 100 characters`

      return `Character limit exceeded. Please use less than ${field.rule.params[0]} characters`
    },
    required: (field) => {
      const fieldName = field.name

      if (fieldName.includes('otherTextFieldName')) {
        return "Meeting point description is required when 'Custom Meeting Point' is selected."
      }

      return `The ${fieldName} field is required`
    },
  },
}
